import gql from 'graphql-tag';

import { shineStartDocumentFragment } from 'features/Onboarding/common/useMatchingShineStartDocumentQuery/fragments';

export const updateShineStartDocumentMutation = gql`
  mutation updateShineStartDocument($input: UpdateShineStartDocumentInput!) {
    updateShineStartDocument(input: $input) {
      ...ShineStartDocument
    }
  }
  ${shineStartDocumentFragment}
`;

export const shineStartDocumentQuery = gql`
  query shineStartDocumentQuery($companyProfileId: ID!) {
    viewer {
      uid
      company: application(companyProfileId: $companyProfileId) {
        applicationId
        companyProfileId
        shineStart {
          shineStartId
          updatedAt
          documents {
            shineStartDocumentId
            shineStartId
            error
            errorLocalized
            status
            type
            typeLocalized
            updatedAt
          }
        }
      }
    }
  }
`;
